// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"styles_tabsContainer__1FIcM","tabItem":"styles_tabItem__35tby","activeTab":"styles_activeTab__2LC6C"};